import LeftSidebar from './LeftSidebar';
import React, { useState, useEffect } from 'react';
import Topbar from './Topbar';
import Footer from './Footer';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { BASE_URL } from '../Config';
import { MDBDataTable } from 'mdbreact';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";

const Members = () => {

  const sendPaymentLink = async (id) => {
    if (!window.confirm("Send payment link to this member?")) return;

    try {
      const res = await axios.post(
        `${BASE_URL}/api/members/${id}/send-payment-link-exist`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        alert(
          "✅ Payment link sent! Razorpay will notify member via SMS/Email."
        );
      } else {
        alert("❌ Failed to send payment link.");
      }
    } catch (err) {
      console.error("Error sending payment link:", err);
      alert("Error sending payment link");
    }
  };


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = localStorage.getItem('token');

  // View modal
  const [showModal, setShowModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);

  // Import modal
  const [showImport, setShowImport] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importStatus, setImportStatus] = useState('');
  const [importBusy, setImportBusy] = useState(false);
  const [importErrors, setImportErrors] = useState([]);
  const [failedRows, setFailedRows] = useState([]);
  const [counts, setCounts] = useState({ inserted: 0, updated: 0 });

  const handleCloseModal = () => setShowModal(false);

  const handleView = (customerId) => {
    setShowModal(true);
    setCustomerLoading(true);
    axios.get(`${BASE_URL}/api/member/${customerId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(response => {
        setDetails(response.data.list || response.data);
        setCustomerLoading(false);
      })
      .catch(error => {
        console.error('Error fetching member details:', error);
        setCustomerLoading(false);
      });
  };
  const sendPassword = async (memberId) => {
    try {
      await axios.post(`${BASE_URL}/api/members/${memberId}/send-password`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Password sent successfully');
    } catch (error) {
      console.error('Error sending password:', error);
      alert('Failed to send password');
    }
  };
  // payment modal states
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [paymentMemberId, setPaymentMemberId] = useState(null);
  const [paymentCurrent, setPaymentCurrent] = useState('');
  const [paymentBusy, setPaymentBusy] = useState(false);
  const openPaymentModal = (e, memberId, currentStatus) => {
    if (e && e.preventDefault) e.preventDefault();
    setPaymentMemberId(memberId);
    setPaymentCurrent(currentStatus);
    setPaymentModalShow(true);
  };

  const closePaymentModal = () => {
    if (!paymentBusy) {
      setPaymentModalShow(false);
      setPaymentMemberId(null);
      setPaymentCurrent('');
    }
  };

  const updatePaymentStatus = async (selectedStatus) => {
    if (!paymentMemberId) return;
    try {
      setPaymentBusy(true);

      // normalize
      const nextStatus = selectedStatus;

      // OPTIONAL: if your backend expects integers instead of strings, map here:
      // const payloadStatus = (nextStatus === 'paid') ? 1 : (nextStatus === 'pending' ? 0 : null);

      await axios.patch(
        `${BASE_URL}/api/members/${paymentMemberId}/payment-status`,
        { payment_status: nextStatus }, // change to payloadStatus if API expects numbers
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // refresh and reset
      await fetchMembers();
      setPaymentModalShow(false);
      setPaymentMemberId(null);
      setPaymentCurrent('');
    } catch (err) {
      console.error('Failed to update payment status', err);
      alert('Failed to update payment status');

    } finally {
      setPaymentBusy(false);
    }
  };




  const [tableData, setTableData] = useState({
    columns: [
      { label: 'Sr.No.', field: 'serial', sort: 'asc' },

      { label: 'Membership', field: 'membership', sort: 'asc' },
      { label: 'Firm Name', field: 'name', sort: 'asc' },
      { label: 'Email', field: 'email', sort: 'asc' },

      { label: 'Membership End Date', field: 'membership_end', sort: 'asc' },
      { label: 'Payment Link', field: 'payment_link', sort: 'asc' },
      { label: 'Firm Mobile No', field: 'mobile', sort: 'asc' },
      { label: 'Send Password', field: 'sendPassword', sort: 'asc' },
      { label: 'Manage Status', field: 'status', sort: 'asc' },
      { label: 'Manage Payment Status', field: 'paymentStatus', sort: 'asc' },
      { label: 'Annual Reset', field: 'annualReset', sort: 'disabled' },
      { label: 'Action', field: 'action', sort: 'asc' },
    ],
    rows: [],
  });


  const formatDate = (value) => {
    if (!value) return 'Not Set';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const getFiscalEnd = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = d.getMonth() + 1; // 1-12
    const endYear = month >= 4 ? year + 1 : year;
    return `${endYear}-03-31`;
  };

  // Get current fiscal start date
  const today = new Date();
  const currentMonth = today.getMonth() + 1; // 1-12
  const currentYear = today.getFullYear();
  let fiscalStartYear = currentMonth >= 4 ? currentYear : currentYear - 1;
  const currentFiscalStart = `${fiscalStartYear}-04-01`;

  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/members`);
      const list = response.data.list || [];

      const rowsWithSerial = list.map((row, index) => {
        const isActive = Number(row.status) === 0; // 0 = Active, 1 = Inactive (per your code)
        const statusColor = isActive ? '#198754' : '#dc3545'; // Bootstrap green/red
        const statusText = isActive ? 'Active' : 'Inactive';

        const isAlreadyReset = row.membership_start_date && row.membership_start_date.substring(0, 10) === currentFiscalStart;

        return {
          serial: index + 1,

          membership: row.membership == null ? 'Not Available' : row.membership,
          name: row.name,
          mobile: row.mobile,
          email: row.email,

          membership_end: formatDate(row.membership_end_date || getFiscalEnd(row.payment_date || row.created_at)),
          payment_link: (
            <>

              <Button
                className="btn btn-primary"
                onClick={() => sendPaymentLink(row.id)}
              >
                <i className="fa fa-credit-card"></i> Send Now
              </Button>


            </>
          ),
          // Clickable status badge
          status: (
            <span
              onClick={() => toggleStatus(row.id, isActive ? 1 : 0)}
              style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: statusColor,
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }}
              title={`Click to mark as ${isActive ? 'Inactive' : 'Active'}`}
            >
              {statusText}
            </span>
          ),
          sendPassword: (
            <span
              style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#007bff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }}
              title="Click to send password"
              onClick={() => sendPassword(row.id)}
            >
              Send Password
            </span>
          ),

          // Actions including Delete
          action: (
            <>
              <Link to={`/member-view/${row.id}`} title="View">
                <i className="fa fa-eye"></i>
              </Link> &nbsp;
              <Link to={`/member-edit/${row.id}`} title="Edit">
                <i className="fa fa-pencil-square-o"></i>
              </Link> &nbsp;
              <span
                title="Delete"
                style={{ cursor: 'pointer', color: '#dc3545' }}
                onClick={() => confirmDelete(row.id)}
              >
                <i className="fa fa-trash"></i>
              </span>
            </>
          ),
          paymentStatus:
            row.payment_status === "pending" ? (

              <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#ffb300ff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block',
                textDecoration: 'none'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status.toUpperCase()}</a>

            ) : row.payment_status === "paid" ? (

              <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#058442ff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status.toUpperCase()}</a>

            ) : (

              <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#f90d0dff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status} </a>
            ),
          annualReset: isAlreadyReset ? (
            <Button
              variant="outline-secondary"
              size="sm"
              style={{
                fontSize: '11px',
                borderRadius: '8px',
                padding: '4px 8px',
                color: '#6c757d',
                borderColor: '#6c757d'
              }}
              disabled
              title="Membership is already set to the current fiscal year (April - March)"
            >
              <i className="fa fa-check"></i> Reset Done
            </Button>
          ) : (
            <Button
              variant="outline-danger"
              size="sm"
              style={{
                fontSize: '11px',
                borderRadius: '8px',
                padding: '4px 8px'
              }}
              title="Reset membership to April-March cycle and mark payment pending"
              onClick={() => handleAnnualReset(row.id, row.name)}
            >
              <i className="fa fa-refresh"></i> Reset Cycle
            </Button>
          ),


        };
      });

      setTableData((prevData) => ({ ...prevData, rows: rowsWithSerial }));
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Toggle status handler
  const toggleStatus = async (id, nextStatus) => {
    try {
      // nextStatus: 0=Active, 1=Inactive (we passed isActive?1:0 above)
      await axios.patch(
        `${BASE_URL}/api/members/${id}/status`,
        { status: nextStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchMembers();
    } catch (e) {
      console.error('Failed to toggle status', e);
      alert('Failed to update status');
    }
  };

  // Delete flow
  const confirmDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this member? This action cannot be undone.')) {
      deleteMember(id);
    }
  };

  const deleteMember = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/members/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchMembers();
    } catch (e) {
      console.error('Failed to delete member', e);
      alert('Failed to delete member');
    }
  };

  const handleAnnualReset = async (id, name) => {
    if (!window.confirm(`Are you sure you want to reset the membership cycle for "${name}" to the current fiscal year (April - March) and set payment status to pending?`)) {
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/api/members/${id}/reset-fiscal-year`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 'success') {
        alert(res.data.message);
        await fetchMembers();
      } else {
        alert('Failed to reset membership cycle.');
      }
    } catch (err) {
      console.error('Failed to reset membership cycle:', err);
      alert('Error resetting membership cycle.');
    }
  };

  // Import handlers
  const openImport = () => {
    setShowImport(true);
    setImportFile(null);
    setImportStatus('');
    setImportBusy(false);
    setImportErrors([]);
    setFailedRows([]);
    setCounts({ inserted: 0, updated: 0 });
  };

  const closeImport = () => setShowImport(false);

  const onFileChange = (e) => {
    const f = e.target.files?.[0] || null;
    if (f && !/\.(csv|xlsx)$/i.test(f.name)) {
      setImportStatus('Only .csv or .xlsx files are supported. Please convert .xls to .csv or .xlsx.');
      setImportFile(null);
      return;
    }
    setImportFile(f);
    setImportStatus('');
    setImportErrors([]);
    setFailedRows([]);
    setCounts({ inserted: 0, updated: 0 });
  };

  const handleImport = async (e) => {
    e.preventDefault();
    if (!importFile) {
      setImportStatus('Please choose a file (.csv or .xlsx).');
      return;
    }

    const formData = new FormData();
    formData.append('file', importFile);

    try {
      setImportBusy(true);
      setImportStatus('Uploading and importing...');
      setImportErrors([]);
      setFailedRows([]);
      setCounts({ inserted: 0, updated: 0 });

      const res = await axios.post(
        `${BASE_URL}/api/import/members`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;
      setImportStatus(data.message || 'Import completed.');
      setCounts({ inserted: data.inserted || 0, updated: data.updated || 0 });
      setFailedRows(data.failed_rows || []);

      fetchMembers();
    } catch (err) {
      if (err.response) {
        const data = err.response.data || {};
        setImportStatus(`Error: ${data.message || 'Import failed'}`);
        if (data.errors) {
          const flat = Object.values(data.errors).flat();
          setImportErrors(flat);
        } else if (data.error) {
          setImportErrors([data.error]);
        } else {
          setImportErrors(['Unknown error occurred.']);
        }
      } else {
        setImportStatus('Network error.');
        setImportErrors([err.message]);
      }
    } finally {
      setImportBusy(false);
    }
  };

  const downloadTemplate = () => {
    const headers = ['membership,name,mobile,mobile_alt,address,area,rep_name_1,rep_mobile_1,rep_name_2,rep_mobile_2,rep_name_3,rep_mobile_3,rep_name_4,rep_mobile_4,rep_name_5,rep_mobile_5'];
    const example = [
      'Gold,Acme Corp,9876543210,9876500000,"12, MG Road",Pune,John,9988776655,Ana,9988776656,Bob,9988776657,Cat,9988776658,Dan,9988776659',
      'Silver,Beta LLC,9123456789,,Plot 10,Mumbai,,,,,,,,,,',
    ];
    const csv = [headers.join(','), ...example].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'members_template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {/* View Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Member Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {customerLoading ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="grow" size="sm" variant="primary" />
              <Spinner animation="grow" size="sm" variant="primary" />
              <Spinner animation="grow" size="sm" variant="primary" />
            </div>
          ) : details ? (
            <div>
              <p className='text-black'><strong>Customer Name:</strong> {details.name}</p>
              <p className='text-black'><strong>Email:</strong> {details.email}</p>
              <p className='text-black'><strong>Mobile No.:</strong> {details.mobile}</p>
              <p className='text-black'><strong>Address:</strong> {details.billing_address}</p>
            </div>
          ) : (
            <p>No customer details available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
        </Modal.Footer>
      </Modal>


      <Modal show={paymentModalShow} onHide={closePaymentModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Payment Status</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <select
            value={paymentCurrent}
            onChange={(e) => setPaymentCurrent(e.target.value)}
            className="form-select mb-3"
          >
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="NA">NA</option>
          </select>

          <p>Choose a status from the dropdown and click <strong>Update</strong>.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closePaymentModal} disabled={paymentBusy}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={() => updatePaymentStatus(paymentCurrent)}
            disabled={paymentBusy || !paymentMemberId}
          >
            {paymentBusy ? 'Saving...' : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>



      {/* Import Modal */}
      <Modal show={showImport} onHide={closeImport}>
        <Modal.Header closeButton>
          <Modal.Title>Import Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: 8 }}>
            <Button size="sm" variant="outline-secondary" onClick={downloadTemplate}>
              Download CSV Template
            </Button>
          </div>
          <form onSubmit={handleImport}>
            <input
              type="file"
              accept=".csv,.xlsx"
              onChange={onFileChange}
              disabled={importBusy}
            />
            <div style={{ marginTop: 12 }}>
              <Button type="submit" disabled={importBusy || !importFile}>
                {importBusy ? 'Importing...' : 'Start Import'}
              </Button>
            </div>
          </form>
          {importStatus && <p style={{ marginTop: 12 }}>{importStatus}</p>}
          {(counts.inserted > 0 || counts.updated > 0) && (
            <p>Inserted: {counts.inserted} | Updated: {counts.updated}</p>
          )}
          {importErrors.length > 0 && (
            <div style={{ color: 'crimson', marginTop: 12 }}>
              <strong>Errors:</strong>
              <ul>
                {importErrors.map((e, i) => <li key={i}>{e}</li>)}
              </ul>
            </div>
          )}
          {failedRows.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <strong>Row validation failures:</strong>
              <ul style={{ maxHeight: 200, overflowY: 'auto' }}>
                {failedRows.map((f, i) => (
                  <li key={i}>
                    Row {f.row}: {Array.isArray(f.errors) ? f.errors.join('; ') : String(f.errors)} | Values: {JSON.stringify(f.values)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeImport} disabled={importBusy}>Close</Button>
        </Modal.Footer>
      </Modal>


      <div>
        <div id="page-top">
          <div id="wrapper">
            <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                <div className="container-fluid">

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Members</h4>
                    <Button variant="success" as="a" href={`${BASE_URL}/api/members/export`}>
                      Export Full CSV
                    </Button>
                    <Button variant="primary" onClick={openImport}>
                      <i className="fa fa-upload" /> Import
                    </Button>
                  </div>

                  <MDBDataTable striped bordered small data={tableData} />
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>


    </>
  );
};

export default Members;
